import { useEffect } from 'react';
import Page from 'shared/types/Page'
import loadPages from 'utils/loadPages'
import Store from 'redux/Store'
import { roles } from 'consts'
import { setMenuPages } from 'shared/redux/actions'
import hasAnyRole from 'shared/utils/hasAnyRole'
import { getAllCustomData } from 'shared/components/App/Auth'

interface useInitProps {
    setPages: Function
    pages: Page[]
    position?: string | boolean | undefined
    menuPages: any
    role: string
    customer?: any
}

const useInit = (props: useInitProps) => {
    useEffect(() => {
        if (props.menuPages?.pages && props.pages.length) {
            
            const customData = getAllCustomData()
            const customerActive = (customData?.customer && (customData.customer.active === 1)) ? true : false
            const isSuperadmin = hasAnyRole([roles.superAdmin])
            const loadFromServer = isSuperadmin || customerActive

            let menusEqual = (props.menuPages.pages.length === props.pages.length)
            
            if (menusEqual) {
                props.menuPages.pages.forEach((item, index) => {
                    if ((item.name !== props.pages[index].name)
                    || (item.path !== props.pages[index].path)
                    || (item.parentPath !== props.pages[index].parentPath)) {
                        menusEqual = false
                    }
                })
            }
            
            if (!menusEqual) {
                loadPages({
                    role: props.role,
                    customer: props.customer,
                    loadFromServer
                }).then((pages) => {
                    props.setPages(pages)
                    Store.dispatch(setMenuPages(pages))
                })
            }
        }
    }, [props.menuPages])
}

export default useInit